// extracted by mini-css-extract-plugin
export default {"modalOverlay":"VQ-z","modalContent":"WQ-z","header":"XQ-z","close":"YQ-z"};